import { IconReceipt2 } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Usd,
} from '#root/components/ui';
import styles from './orderPriceDialog.module.scss';

interface OrderPriceDialogProps {
  open: boolean;
  onClose: () => void;
  /** Pedido regular: `tit`, `pre` (precio referencial) y `com` (comisión propuesta) */
  order: any;
}

/**
 * Qué son el precio referencial y la comisión propuesta de un pedido regular. Lo abre el
 * sub-card de precio de la lista de pedidos y del drawer de oferta.
 */
const OrderPriceDialog = ({ open, onClose, order }: OrderPriceDialogProps) => (
  <Modal open={open} onClose={onClose} size="sm">
    <ModalHeader icon={<IconReceipt2 />} tone="info">
      <ModalTitle>Precio referencial y comisión propuesta</ModalTitle>
      {order?.tit && <ModalDescription>{order.tit}</ModalDescription>}
    </ModalHeader>
    <ModalBody>
      <dl className={styles.terms}>
        <div className={styles.term}>
          <dt>
            <span>Precio referencial</span>
            <strong>
              <Usd value={order?.pre} />
            </strong>
          </dt>
          <dd>
            El precio del producto en la tienda, según el comprador. Puede no incluir tax ni envío:
            el precio real, con TAX y shipping, lo defines tú al hacer tu oferta.
          </dd>
        </div>
        <div className={styles.term}>
          <dt>
            <span>Comisión propuesta</span>
            <strong>
              <Usd value={order?.com} />
            </strong>
          </dt>
          <dd>
            Lo que el comprador propone pagarte por traerlo. Puedes proponer otra al hacer tu
            oferta.
          </dd>
        </div>
      </dl>
    </ModalBody>
    <ModalFooter>
      <Button onClick={onClose}>Entendido</Button>
    </ModalFooter>
  </Modal>
);

export default OrderPriceDialog;
